// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__r_dIf","log":"ModalInventoryLogs_log__2H8Mu","date":"ModalInventoryLogs_date__25zql","userName":"ModalInventoryLogs_userName__3n84v"};